import { Component, Input, OnInit } from '@angular/core';
import { Language } from 'Angular/src/app/shared/model';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  @Input() selectedLanguage: Language;
  @Input() shouldShowSupportInformation: boolean;

  public chatLink: string;

  constructor() { 

  }

  public ngOnInit() {
    this.changeChatLanguage();
  }

  private changeChatLanguage()
  {
    if(!!this.selectedLanguage && !!this.selectedLanguage.LanguageCode) {
      if (this.selectedLanguage.LanguageCode.toString() === "en")
      {
        this.chatLink = environment.chatEnglish;
      }
      else if (this.selectedLanguage.LanguageCode.toString() === "fr")
      {
        this.chatLink = environment.chatFrench;
      }
      else if (this.selectedLanguage.LanguageCode.toString() === "de")
      {
        this.chatLink = environment.chatGerman;
      }
      else if (this.selectedLanguage.LanguageCode.toString() === "es")
      {
        this.chatLink = environment.chatSpanish;
      }
      else if (this.selectedLanguage.LanguageCode.toString() === "nl")
      {
        this.chatLink = environment.chatDutch;
      }
      else if (this.selectedLanguage.LanguageCode.toString() === "it")
      {
        this.chatLink = environment.chatItalian;
      }
    } else {
      this.chatLink = environment.chatEnglish;
    }
  }
}
